import React from 'react';
import StripePaymentForm from './StripePaymentForm';

/**
 * Payment Method Setup Modal
 * Used when users want to add/update their payment method from profile
 * Uses the consolidated StripePaymentForm component
 */
const PaymentMethodSetup = ({ isOpen, onClose, onSuccess }) => {
  if (!isOpen) return null;

  const handleSuccess = (data) => {
    onSuccess(data);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 sm:p-8 max-w-md w-full mx-4">
        <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Add Payment Method</h3>
        
        <StripePaymentForm 
          onSuccess={handleSuccess}
          onCancel={onClose}
          showUpgradeNotice={false}
        />
      </div>
    </div>
  );
};

export default PaymentMethodSetup;
